import {checkChatRateLimit, CHAT_RATE_LIMIT_KINDS} from '../../../utils/chat/chatRateLimit';
import {MATCH_CHAT_OUTGOING_STATUSES} from './matchChatReducer';

// Состояние до первого экшена (и в тестах, где слайса в сторе нет)
const EMPTY_MATCH_CHAT = Object.freeze({
  isPaused: false,
  outgoing: Object.freeze([]),
  sentAtHistory: Object.freeze([]),
  retryNotBefore: null,
});

export const selectMatchChatState = (state) => state.private?.matchChat || EMPTY_MATCH_CHAT;
export const selectMatchChatIsPaused = (state) => Boolean(selectMatchChatState(state).isPaused);
// Свои сообщения, которых еще нет в общей переписке: в пути, на проверке, отклоненные
export const selectMatchChatOutgoing = (state) => selectMatchChatState(state).outgoing || EMPTY_MATCH_CHAT.outgoing;

export const MATCH_CHAT_SEND_BLOCK_KINDS = {
  // Модератор недоступен — чат на паузе
  PAUSED: 'paused',
  // Уже MODERATED_CHAT_MAX_PENDING сообщений на проверке — ждать вердиктов
  PENDING_LIMIT: 'pending_limit',
  // Слишком часто — ждать waitMs
  COOLDOWN: 'cooldown',
};

/**
 * Можно ли отправить сообщение в модерируемый чат прямо сейчас — те же
 * лимиты, что проверит сервер (checkChatRateLimit по своей истории
 * отправок), плюс срок из его последнего отказа «слишком часто». Кнопка
 * просто не дает нарваться на заведомый отказ; решает все равно сервер.
 *
 * @param {Object} matchChatState - слайс matchChat
 * @param {number} now - часы клиента (в них же записана история отправок)
 * @returns {{canSend: boolean, kind: string|null, waitMs: number|null}}
 */
export const getMatchChatSendBlock = (matchChatState, now) => {
  const {isPaused, outgoing = [], sentAtHistory = [], retryNotBefore} = matchChatState || EMPTY_MATCH_CHAT;
  if (isPaused) {
    return {canSend: false, kind: MATCH_CHAT_SEND_BLOCK_KINDS.PAUSED, waitMs: null};
  }
  const pendingCount = outgoing.filter((entry) => entry.status === MATCH_CHAT_OUTGOING_STATUSES.SENDING
    || entry.status === MATCH_CHAT_OUTGOING_STATUSES.PENDING).length;
  const limit = checkChatRateLimit({sentAtHistory, pendingCount, now});
  if (!limit.allowed && limit.limit === CHAT_RATE_LIMIT_KINDS.MAX_PENDING) {
    return {canSend: false, kind: MATCH_CHAT_SEND_BLOCK_KINDS.PENDING_LIMIT, waitMs: null};
  }
  const waitMs = Math.max(
    limit.allowed ? 0 : (limit.retryAfterMs ?? 0),
    typeof retryNotBefore === 'number' ? retryNotBefore - now : 0,
  );
  if (waitMs > 0) {
    return {canSend: false, kind: MATCH_CHAT_SEND_BLOCK_KINDS.COOLDOWN, waitMs};
  }
  return {canSend: true, kind: null, waitMs: null};
};
